import { render, staticRenderFns } from "./SVGSearch.vue?vue&type=template&id=119838c2&scoped=true&"
import script from "./SVGSearch.vue?vue&type=script&lang=js&"
export * from "./SVGSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119838c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('119838c2')) {
      api.createRecord('119838c2', component.options)
    } else {
      api.reload('119838c2', component.options)
    }
    module.hot.accept("./SVGSearch.vue?vue&type=template&id=119838c2&scoped=true&", function () {
      api.rerender('119838c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGSearch.vue"
export default component.exports